import type { ReactNode } from 'react';
import OnelivePageLayout from './OnelivePageLayout';
import OneliveMobileMembersPanel from './OneliveMobileMembersPanel';

export type MypageHistoryTab = 'coin' | 'charge' | 'exchange';

interface Props {
  children?: ReactNode;
  pageClassName?: string;
}

/** 마이페이지 관리 헤더 레이아웃 (/mypage/profile) */
export default function OnelivePcMypageShell({ children, pageClassName }: Props) {
  const pageClass = ['onelive-pc-mypage-page', pageClassName].filter(Boolean).join(' ');

  return (
    <OnelivePageLayout pageClassName={pageClass}>
      <section className="onelive-members-wrap onelive-pc-mypage-wrap">
        <OneliveMobileMembersPanel>{children}</OneliveMobileMembersPanel>
      </section>
    </OnelivePageLayout>
  );
}
